module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_piano_df8adc82e496dcf8036c172f3f540bbe.png";